import axios from "@/axios";

export const namespaced = true

export const state = {
    emailExtensions: []
}

export const getters = {
    emailExtensions: (state) => state.emailExtensions
}

export const mutations = {
    SET_EMAIL_EXTENSIONS: (state, response) => (state.emailExtensions = response.data),
}

export const actions = {
    async getEmailExtensions({ commit }) {
        commit('SET_EMAIL_EXTENSIONS', await axios.get("/api/emailextensions"))
    },

    async getEmailExtensionPaginate({ commit }, pageInfo) {
        commit(
          "SET_EMAIL_EXTENSIONS",
          await axios.get(
            `/api/emailextensions/${pageInfo.pageNumber}/${pageInfo.pageCount}/${pageInfo.searchText}`
          )
        );
      },

    saveEmailExtension({ commit}, model ) {
        return new Promise((resolve, reject) => {
            var data = {
                Id: model.id || 0,
	            CountryId: model.countryId,
	            Type: model.type,
	            Ext: model.ext
            };

           axios.post('/api/emailextensions', data,  { config:{ showToast: true, message: "Extension's Sucessfully Saved!!"}})
                .then(() => resolve())
                .catch((error) => reject("There was an error saving the item to the server."))
        });
    },

    removeEmailExtension({ commit}, id ) {
        return new Promise((resolve, reject) => {
           axios.delete(`/api/emailextensions/${id}`,  { config:{ showToast: true, message: "Email Extension's Sucessfully Removed!!"}})
                .then(() => resolve())
                .catch((error) => reject("There was an error removing the item to the server."))
        });
    }
}
